export default {
  login: {
    code: "验证码",
    phone_code: "手机验证码",
    code_pla: "请输入验证码",
    get_code: "获取验证码",
    send_code: "秒后可重新获取",
    password_pla: "请输入密码",
    forget_password: "忘记密码",
    password: "密码",
    mobile_pla: "请输入手机号",
    mobile_pla_bind: "请输入要绑定的手机号",
    mobile: "手机号",
    bind_mobile: "绑定手机号",
    bind_mobile_tip: "根据国家政策，请绑定手机号码再继续",
    tips_text: "使用手机获取验证码即可自动注册或登入",
  },
  toast: {
    switchLangSuccess: "切换中文成功",
  },
  route: {},
  common: {
    rate: "今日汇率",
    huilv: "汇率",
    please_enter: "请输入",
    please_choose: "请选择",
    add: "新增",
    delete: "删除",
    delete_modal: "是否确认删除？",
    edit: "编辑",
    bind: "绑定",
    unbind: "取消绑定",
    submit_btn: "确认",
    submit_btn2: "确定",
    cancel_btn: "取消",
    empty: "暂无数据",
    help_title: "您好，有什么可以帮助到您？",
    help_des: "请输入关键词，如：运费、手续费、物流等",
    choose: "必选",
    submit_success: "提交成功",
    add_success: "添加成功",
    delete_success: "删除成功",
    update_success: "更新成功",
    setting_success: "设置成功",
    operation_success: "操作成功",
    pay_success: "支付成功",
    logout_success: "退出成功",
    bind_success: "绑定成功",
    unbind_success: "取消绑定成功",
    login_success: "登录成功",
    cancel_reservation_success: "取消预约成功",
    cancel_order_success: "取消订单成功",
    confirm_receive_success: "确认收货成功",
    collect_success: "收藏成功",
    cancel_collect_success: "取消收藏成功",
    track_success: "追踪成功",
    cancel_track_success: "取消追踪成功",
    recharge_success: "储值成功",
    upload_image_required: "请上传图片",
    image_too_large: "图片过大，请重新上传",
    requirement_required: "请填写需求",
    required_fields_missing: "有必填项未填写",
    binning_count_required: "请输入分箱数量",
    query_info_required: "请输入查询信息",
    consignee_required: "请选择收货人信息",
    transport_method_required: "请选择运输方式",
    delete_items_required: "请选择要删除的商品！",
    auction_level_unchanged: "竞拍等级没有变化",
    id_card_images_required: "请补全证件正反面照片",
    id_name_number_required: "请补全真实姓名和证件号码",
    ezway_required: "请选择EZ WAY 易利委",
    name_required: "请输入姓名",
    mobile_required: "请输入手机号码",
    id_number_required: "请输入身份证字号",
    coupon_code_required: "请输入优惠券代码",
    product_data_missing: "商品数据不存在",
    variant_not_found: "未找到匹配的变体信息",
    add_to_cart_failed: "加入购物车失败",
    add_to_cart_retry: "加入购物车时发生错误，请重试",
    copy_fail_manual: "复制失败，请手动复制",
    network_error_keep: "网络异常，已保留上次的列表数据",
    network_error_retry: "网络异常，请稍后重试",
    submit_fail: "提交失败",
    mfree: "免费",
    xsj: "项数据",
    zwsj: "暂无数据",
    zhang: "张",
    mai: "卖",
    copy: "复制",
    jia: "价",
    xiang: "项",
    dian: "点",
    xtb: "新台币",
    rmb: "人民币",
    zhanshi: "展开",
    active_tab_footer_1: "显示全部平台",
    active_tab_footer_2: "仅显示当前平台",
    notice_read_1: "全部标示已读",
    loading: "加载中...",
  },
  navBar: {
    userName: "用户名",
    please_login: "请登入",
    my_package: "我的包裹",
    user_center: "会员中心",
    help_center: "帮助中心",
    auctions: "竞拍中心",
    app_download: "APP下载",
  },
  home: {
    title: "人气网站",
    category: "日淘晒单",
    category2: "日淘攻略",
  },
  calculate: {
    btx: "请输入必填选项",
    title: "费用计算机",
    fyys: "费用预算",
    title_tip: "您可以使用此计算机，预算代标 / 代购时所需要的费用总和。",
    btxm: "为必填项目",
    jsgj: "寄送国家・地区",
    goods_price: "商品价格／中标价格",
    zlcc: "重量 / 尺寸",
    lenght: "长度",
    width: "宽度",
    height: "高度",
    cn_fee: "代购手续费",
    fee: "国内运送费",
    zzsxf: "转账手续费",
    agency_fee: "出口代理费（代日本邮政收取）",
    yg: "預估",
    zysx: "注意事项",
    tips1: "报价内容仅供参考，根据实际情况最终金额可能出现变动。",
    tips2: "报价收取的费用不包括进口国关税。",
    tips3:
      "除邮政线路，当“体积重量”大于“实际重量”时，计费重量按照体积重量计算。",
    js: "计算",
    ysjg: "费用预算结果",
    fk: "付款",
    gjyf: "国际运费",
    fsfs: "可选择的发送方式",
    xskf: "线上客服",
    scwz: "收藏网站",
    top_back: "返回顶部",
    ygsx: "预估时效",
    yjsm: "【说明】",
    charge_weight_rule: "计费方式",
    charge_rule_volume: "体积重量（长*宽*高cm / {divisor}）",
    charge_rule_actual: "实际重量",
    max_amount: "总金额（单个商品除外）",
    max_amount_hint: "{amount}人民币以内",
    customs_approval: "海关备案",
    need_approval_yes: "需要",
    need_approval_no: "不需要",
  },
  other: {
    total_weight: "总重量",
    gjyf: "国际运费",
    history: "搜索历史",
    jp_search: "日文词搜索",
    zh_search: "中文词搜索",
    open_all: "展开全部",
    history_modal: "您确定要删除搜索历史吗？",
    history_modal_all: "您确定要清空搜索历史吗？",
    keyword_modal_all: "您确定要删除这个关键字吗？",
    rmtj: "热门推荐",
    keyword_place: "请输入商品名称、商品ID、官网链接…",
    goods_name: "商品名称",
    goods_type: "项目",
    goods_value: "货值",
    goods_num: "商品数量",
    pack_weight: "包裹重量",
    update_time: "更新时间",
    goods_name_place: "请输入商品名称",
    more_xscc: "更多线上商城",
    my_zj: "我的足迹",
    shipment_disabled_hint: "含不可发送包裹，",
    view_disabled_reasons: "点击查看原因",
    shipment_disabled_title: "不可发送原因",
    no_disabled_reasons: "暂无原因说明",
    tax_included: "包税",
    clearance_included: "包清关",
    keyword_text: "关键词",
    search_keyword: "搜索词",
    dp: "代购/代拍",
    dp_1: "请输入商品或拍卖网址，即可跳转至下一个操作页面。",
    checkbox: "全选",
    serviceRadio: "已阅读并同意",
    serviceRadio2: "《钱包服务协议》",
    serviceRadio3: "请仔细阅读并勾选服务协议",
    checkbox_1: "已选择",
    order_id: "订单ID",
    wait_weight: "待称重",
    tofh: "去发货",
    wait_package: "待打包",
    wait_pay_ship_fee: "待付国际运费",
    wait_send_package: "待发出",
    sqgd: "申请工单",
    checkOff: "清点核对",
    binning: "分箱服务",
    returnForward: "退货转寄",
    photos: "拍照服务",
    nullification: "废弃申请",
    submit_fahuo: "提交发货",
    gd_details: "工单详情",
    cart: "购物车",
    jst: "结算台",
    zbgm: "暂不购买",
    ydty: "已阅读和同意",
    zyts: "重要提示",
    qnqr: "请您确认",
    order_tip1:
      "您好！请您在购买前务必认真阅读并完全理解本提示的全部内容，并对自身承受风险的能力进行判断后再下单购买。具体提示如下：",
    order_tip2: "- 关于退换货、取消订单",
    order_tip3:
      "您在买到手平台下单付款后，买到手会立即按您选择的商品在境外完成采购并支出采购费用。且与国内不同的是，境外无“7天无理由退货”的相关法律规定，因此买到手无法提供无理由退货的服务。您下单付款后，非因买到手的过错，您无法取消订单，敬请理解。",
    order_tip4: "- 关于发票",
    order_tip5:
      "您在买到手平台选择代购的商品，所有费用均是向买到手的境外合作伙伴进行付费，买到手在中国大陆的经营主体并非销售主体，因此该费用无法向您提供国内的发票，境外合作伙伴也仅能依据当地法律向您开具相应凭证，无法开具国内发票。若您需要境外合作伙伴开具凭证，可联系客服处理。",
    order_tip6: "- 关于退款",
    order_tip7:
      "若因卖家无法发货、商品缺货、商品下架等非用户原因，导致订单无法继续履行的，您已支付的款项将原路退还至您的买到手账户余额中。账户余额可用于继续支付平台内的任何资费，如您申请将余额提现至原支付账户，平台将按照提现金额收取 2% 的提现手续费。",
    order_tip8: "- 关于检品服务",
    order_tip9:
      "买到手为您代为采购商品后，根据您的选择，可以直接为您办理货运服务，不会打开卖家邮寄的包裹；若您有顾虑，您也可以选择买到手的检品服务，工作人员将为您打开包裹进行外观检查（人工检查），但检品服务需要您额外支付费用，具体费用标准详见服务说明。",
    order_tip10: "- 关于商品",
    order_tip11:
      "若发生实物与描述不一致、错发漏发、假货等问题，应由商品的境外卖家承担相应责任，买到手无法承担非买到手自身原因之外的退换货或赔偿责任，敬请理解。商品若为二手商品，请注意其与新品之间存在差异。您选择的商品来自境外，境外有关质量、安全、卫生、环保、标识等标准可能与我国标准存在差异，请您理解。",

    goods_details_txt: "商品详情",
    shipment_step1: "发货信息",
    shipment_step2: "申报信息",
    shipment_step4: "增值服务",
    consignee_title: "收货人信息",
    ezway: "EZ WAY 易利委",
    ezwayadd: "添加 EZ WAY 易利委",
    ezway_empty_tip: "请添加EZ WAY 易利委信息",
    address: "新增收货地址",
    choose_pack: "选择的包裹",
    order_num: "订单号",
    wait_shenbao: "委托填报申报信息",
    zx_wait_shenbao: "自行填报申报信息",
    declare_version_default: "逐项申报（按商品）",
    declare_version_simple: "合并申报（按包裹）",
    add_declare: "新增",
    weituo_des:
      "委托日本仓库代为填写出口报关单，避免因申报信息不完整导致包裹被退回。费用按订单内「包裹总数」计算，每件 150 日元。",
    shipment_pause: "暂不发货",
    declare_fee_title: "委托填报费用",
    declare_fee_count: "包裹数量",
    declare_fee_unit: "单价",
    declare_fee_total: "合计",
    declare_fee_currency: "日元",
    declare_fee_unit_suffix: "个",
    weituo_des2: "",
    weituo_des3:
      "根据海关要求，请如实填写商品信息（内件品名、数量、价格），以确保顺利通关。",
    declare_confirm_content:
      "我已确认以上申报信息由本人提供并确认无误，因申报信息不实或遗漏所产生的一切后果，将由本人自行承担，与平台及其合作方无关。",
    declare_confirm_cancel: "我再考虑一下",
    declare_confirm_ok: "我已确认",
    declare_price_floor_tip: "申报总价不能小于实际购买商品的总价",
    declare_price_floor_tip_with_amount: "系统监测申报价格应不小于 {amount} 日元",
    declare_risk_low_title: "低风险确认",
    declare_risk_medium_title: "中风险确认",
    declare_risk_high_title: "高风险确认",
    declare_risk_warning_title: "申报合规预警触发",
    declare_risk_level_label: "风险等级",
    declare_risk_level_low: "低风险",
    declare_risk_level_medium: "中风险",
    declare_risk_level_high: "高风险",
    declare_risk_ratio_label: "申报比例",
    declare_risk_info_true: "我确认申报信息真实",
    declare_risk_understand_customs: "我理解可能被海关要求补充凭证",
    declare_risk_reason_required: "请选择申报与系统监测有偏差的原因",
    declare_risk_reason_1: "商品入库后存在缺失",
    declare_risk_reason_2: "商品入库后存在丢失、破损",
    declare_risk_reason_3: "商品入库后与实际购买内容不符",
    declare_risk_reason_4: "商品入库后存在拆分的情况",
    declare_risk_reason_other: "其他原因",
    declare_risk_reason_other_placeholder: "请输入合理原因",
    declare_risk_high_ack:
      "为确保通关顺利，该订单可能由系统审核并协助完成申报，也可能存在被取消订单的情况。",
    declare_risk_high_limit_hint:
      "当月高风险申报超过1次时，系统将不允许自动进入发货流程，请更正申报金额。",
    declare_risk_blocked_default:
      "您本月高风险申报次数已达到限制，该订单需进入系统审核流程，暂不可自行继续提交发货。",
    declare_num_invalid: "申报数量需为大于0的整数",
    declare_price_invalid: "申报单价需为大于0的整数",
    modify_reason_title: "修改原因",
    modify_reason_1: "商品内容/数量/价格与实际不符",
    modify_reason_2: "原申报价值未包含实际应计费用",
    modify_reason_3: "商品实际状态影响价值认定",
    modify_reason_4: "卖家提供的商品信息发生变更",
    modify_reason_5: "商品实际信息与平台展示内容存在差异",
    declare_required: "请为每个商品至少填写一条申报信息",
    declare_name_required: "请输入申报名称",
    declare_num_required: "请输入申报数量",
    declare_price_required: "请输入申报单价",
    custom_name: "申报名称",
    custom_price: "单价",
    custom_price2: "申报单价",
    service_text: "运费为预估价格，依据最终打包完成后的重量确定实际运费。",
    ship_method_available: "线路可发",
    ship_method_unavailable: "超出发货限制",
    ship_method_max_weight: "最大重量",
    ship_method_max_length: "长度（最长边）",
    ship_method_max_total: "最长边 + 周长合计",
    ship_method_eta: "配送时效（参考）",
    ship_method_volume_weight_limit: "体积重超出限制",
    service_desc: "请填写方式，如未填写默认加固全部商品",
    xqbc: "需求补充",
    ts_text: "特殊要求请填写在这，工作人员会在合理的范围内对用您的要求",
    tsbz: "发货备注",
    service_process: "服务流程",
    wait_dbwc: "等待打包完成",
    wait_notice: "打包完成将会推送通知",
    pay_gjyf: "支付国际运费",
    fh_wc: "发货完成",

    wxts: "温馨提示",
    qxdd: "确定要取消订单吗？",
    qxyycj: "确定要取消预约出价吗？",
    qrsdhw: "请确认您已收到货物。",
    read_msg: "您确定要全部标记成已读吗？",
    qxbd: "确定要取消绑定吗？",
    close: "关闭",
    open: "开启",
    kqwxtz: "确定要开启微信通知吗？",
    qxwxtz: "确定要关闭微信通知吗？",
    kqwxtzcg: "开启微信通知成功",
    qxwxtzcg: "关闭微信通知成功",
    请使用微信扫描二维码绑定: "请使用微信扫描二维码绑定",
    请使用微信扫描二维码登入: "请使用微信扫描二维码登入",
    gmykj_des: "购买一口价商品需要账户余额充足",
    fzcghwf: "支付后无法取消订单，请谨慎考虑后再进行支付",
    current_price: "当前金额",
    min_jj: "最低加价金额",
    qr_zdjj: "请确认是否以最低金额",
    jxjb: "继续竞标",
    zy: "我们支持取消发货，取消发货后，包裏将返回到待发货状态，您可以重新选择打包并且发货，此时如果该包裹已经打包，产生合箱费用的，需要支付合箱费用后才可以继续发货。确定要取消发货吗？",
    gy_ysfs: "更改运输方式",
    ship_method_address_missing: "无法获取地址信息",
    ship_method_change_success: "运输方式更改成功",
    ship_method_change_failed: "运输方式更改失败",
    use_ship_method: "使用此运输方式",
    gjwlf: "国际物流费",
    sxf: "手续费",
    hj: "合计",

    qxfh: "取消发货",
    del_sell: "删除已售",
    del_all: "清空全部",
    del_all_history: "清除搜索历史",
    del_check: "删除选中",
    yf_ss: "运费试算",
    qjz: "去结账",
    gzd: "个账单",
    country_place: "选择收货地区",

    select_service: "可选服务",
    photo_des:
      "请注意：若您选择的拍照服务类型与您实际的拍照需求不符，仓库将不予进行服务操作，直接退回您的拍照服务费用",
    photo_des2: "对于可选服务的任何要求，您可直接填写在商品备注中",
    back_card: "返回修改购物车",

    wallet: "可用余额",
    fwfy: "服务费用",
    see_inbound_photo: "查看入库照片",
    see_all_yhj: "查看所有优惠券",
    wzlj: "网站链接",
    jzq: "在截止拍卖前5分钟时出价的金额",
    jp1: "本次竞拍至少加价",
    clear_jp: "清空竞拍结束的收藏",
    jp2: "预约下标会在拍卖结束大约5分钟前由系统自动下标。",
    jp3: "您输入的最高下标价格在拍卖结束前已被其他买家超过，则预约下标失败",
    jp4: "拍卖卖家提前取消了拍卖，则预约下标失败",
    jp5: "当您申请预约下标后，将无法对同一个拍卖再进行通常的下标。请取消预约下标后再进行通常的下标。",
    jp6: "拍卖结标前15分钟起即不受理取消以及下标",
    ljxb: "立即下标",
    yyxb: "预约下标",
    sy_time: "剩余时间",
    ykjgm: "一口价购买",
    dd_totale: "订单总额",
    gw_link: "官网直链",
    xbls: "下标历史",
    copy_share: "复制成功去分享吧",
    copy_success: "复制成功",
    copy_fail: "复制失败",
    xjia: "现价",
    yjfw: "议价服务",
    yjje: "请输入议价后购买的金额",
    yjbcg: "如果议价不成功则以原价购买",
    hxyy: "还是想拥有它",
    hxyy1: "超过2小时卖家未回复议价信息，系统将自动为您以当前价格购买商品，请知悉。",
    yjdes:
      "请注意：进行议价则无法自动下单购买，需要人工确认后才能购买。当客服非处于在线状态时，将无法为您处理议价事宜（9:00 - 16:30在线），这可能会导致商品在未得到您的最终确认前就被其他人购得。",
    close_btn: "关闭",
    qxyj: "取消议价",
    yebz: "您当前的余额不足",
    discounts_date: "限时特价",
    qing: "请",
    whs: "未含税",
    smzf: "扫码支付",
    zfwt: "支付遇到问题？联系客服",
    zfwc: "已完成支付",
    qrxykzf: "请您在新窗口中使用信用卡进行支付。",
    yj: "议价",
    cpjg: "产品价格",
    tjgd: "提交工单",
    jlms: "请您尽量描述您的需求，我们会尽量按照您的需求来执行",
    fqhwfzh: "废弃后无法追回，请确认是否继续？",
    jplb: "竞拍类别",
    checkoff1: "填写包裹详情提交后，可代为核对清点实际到货商品及数量是否一致",
    checkoff2:
      "1~10件 200日元， 11~20件 300日元， 21~30件 400日元， 31~40件 500日元，以此类推",
    checkoff3: "若为填写包裹详情收费x2计算",
    checkoff4: "提交核对申请后无法取消，请您理解与知悉！",
    checkoff5: "我确定包裹内容，希望核对数量",
    add_wait_qd: "新增待清点商品",
    jcssrsz: "仅支持输入数字",
    bqdbrnr: "我不确定包裹内容，希望核对数量",
    bgtz: "买到手将为您清点全部包裹并进行告知，请提交后关注【APP站内信通知】",
    binning1: "将包裹内指定的物品取出组成新的包裹。",
    binning2:
      "分箱完成后，将会有新的包裹入库，同时会发送分箱完成的通知至您的App，请注意查收。",
    binning3: "若未填写包裹详情的我们会将一个包裹平均分成多个包裹。",
    binning4:
      "1~10件300日元；11~20件500日元；21~30件700日元；31~40件900日元，依此类推。",
    binning5: "提交分箱申请后无法取消，请您理解与知悉",
    binning6: "我希望准确按照要求分箱",
    add_binning: "新增分箱明细",
    fz: "分组",
    pjfx: "我希望粗略平均的分箱",
    xypjfx: "想要平均分成箱数",
    fxsl: "分箱数量",
    del_goods_notice: "确定要删除商品吗?",
    del_goods_notice_all: "确定要清空全部数据吗?",
    pmtip: "在截至拍卖前5分钟时出价的金额",
    tag2: "几乎未使用",
    tag3: "没有明显的划痕和污垢",
    tag4: "有一些划痕或污垢",
    tag5: "有明显划痕或污垢",
    tag6: "总体状态较差",
    quantity: "数量",
    customizationValue:
      "以下信息如与代购无关或不确定填写方式，可不填写，买手将视实际情况代为填写。",
    remainingStock: "剩余库存",
    service_tip1: "本站服务条款",
    service_tip2: "订购前须知",
  },
  return_forward: {
    notice:
      "包裹进行退货或转寄其他日本境内地址时，每一个包裹收取500日元手续费+代购商品总金额10%，运费实收（不支持合箱）",
    notice2: "此包裹转寄至",
    name: "收货人",
    name_place: "收货人姓名",
    mobile: "电话号码",
    mobile_place: "收货人电话号码",
    country: "所在地区",
    address: "转寄地址",
    zipcode: "邮政编码",
    zipcode_place: "所在地的邮编",
    desc_place: "备注信息",
  },
  photo_service: {
    notice: "提供客户指定的拍照内容，或扫描包裹内文件，收取500日元",
    notice2: "您可以在下方简单描述您拍照的需求",
    xzxq: "拍照需求",
    xzxq_place: "请您尽量描述您的需求，我们会尽量按照您的需求来完成拍照",
  },
  nullification: {
    notice: "根据实际包裹商品内容、重量、体积计算费用",
    notice2: "您可以将其他补充需求填写到下方输入框",
  },
  personal_nav_list: {
    order: "我的订单",
    package_details: "包裹详情",
    auction_order: "竞拍订单",
    service_work_order: "服务工单",
    personal_information: "个人资料",
    fund_management: "资金管理",
    address_management: "地址管理",
    account_settings: "账户设定",
    identity_authentication: "身份认证",
    auction_credit_rating: "竞拍信用等级",
    user_level: "会员等级",
    my_collection: "我的收藏",
    rmss: "热门搜索",
    zyaddress: "转运地址",
    coupon: "优惠劵",
    points: "积分",
    cyjf: "持有积分",
    cyjf2: "持有",
    zdjf: "本单最多可用",
    balance: "余额",
    coupons: "优惠券",
  },
  user_level: {
    cgz: "成长值达到",
    ksj: "可升级",
    wdc: "未达成",
    ydc: "已达成",
    ydcdj: "已达到此等级",
    sjtq: "升级获得更多特权",
    cqhyk: "出示会员卡",
    hxy: "还需要",
    chengzz: "成长值",
    djfl: "等级福利特权",
    m: "运费积分回馈",
    photo_text: "入库前包裹拍照",
    yhj: "专属优惠券",
    kf: "专属客服",
    date_dialog: "当前等级将到期，届时将根据您的成长值重新评价会员等级",
  },
  address_info: {
    name: "收货人",
    mobile: "手机号码",
    invite_num: "推荐人代码",
    invite_title: "邀请您注册买到手",
    invite_title2: "日本优品轻松买到手",
    djcg: "注册成功！",
    xzdj: "请下载APP使用填写的手机号码登入",
    btn_text: "登入并下载APP",
    country_name: "所在地区",
    address: "详细地址",
    zipcode: "邮政编码",
    checked: "默认",
    verified_label: "实名认证",
    verified_status_failed: "未通过",
    select_verified_recipient: "选择已实名认证的收件人",
    choose_verified_recipient: "选择",
    select_verified_recipient_error: "请选择已实名认证的收件人",
    no_verified_recipient: "暂无已实名认证的收件人",
    submit_identity_auth: "提交实名认证",
    name_required: "请填写收货人姓名",
    mobile_required: "请填写收货人手机号码",
    country_required: "请选择所在地区",
    address_required: "请输入您的详细地址",
    tip: "提醒：下次发货会优先使用此地址",
  },
  account_info: {
    sfwtg: "您的身份信息审核未通过，请重新上传",
    zsh: "正在审核您的身份信息…",
    ysc: "已上传您的身份信息",
    edit: "修改信息",
    realname: "真实姓名",
    cardnum: "证件号码",
    scsfz: "上传您的身份证照片",
    scsfz_1: "确保照片画面清晰，且身份证件正面的照片能清楚显示您的面部",
    gjmds: "我们根据买到手的",
    ys: "隐私政策",
    cl: "处理您的身份信息，承诺身份信息仅用作提供给海关的报关、清关资料使用",
    submit: "提交认证",
    auth_mode_hint: "以下两种认证方式，任选其一即可",
    auth_mode_ocr: "上传身份证正反面",
    auth_mode_id2: "输入姓名和身份证号",
    id2_title: "输入姓名与证件号码",
    id2_desc: "无需上传照片，填写真实姓名与证件号码即可",
    submit_processing_title: "提交认证中",
    submit_processing_desc: "审核中，请稍候",
    submit_processing_countdown: "预计 {sec} 秒内审核完毕",
    submit_processing_wait: "请耐心等待",
    submit_processing_timeout:
      "验证超时，请重新提交认证",
    verified_list_title: "已通过实名认证",
    add_verified: "新增实名认证",
    verified_status: "状态",
    verified_status_passed: "已通过",
    no_verified: "暂无已通过实名认证",
    user_id: "会员ID",
    nickname: "昵称",
    mobile: "联系方式",
    email: "绑定邮箱",
    wechat: "微信登录",
    line: "绑定LINE",
    password: "密码管理",
    edit_pass: "修改密码",
    edit_nickname_title: "更新昵称",
    nickname_label: "昵称",
    verify_old_mobile_title: "验证原手机号码",
    bind_mobile_title: "请确认您的手机号码可以接收到简讯",
    mobile_label: "手机号码",
    bind_mobile_placeholder: "请输入要绑定的手机号码",
    edit_password_title: "修改密码",
    old_password_label: "原密码",
    new_password_label: "新密码",
    confirm_password_label: "确认新密码",
    password_mismatch: "两次密码输入不一致",
    id_number_label: "身份证字号",
    verify_old_email_title: "验证原电子邮箱",
    bind_email_title: "请输入您要绑定的邮箱",
    email_label: "电子邮箱",
    bind_email_placeholder: "请输入要绑定的电子邮箱",
    verify_success: "验证成功",
    send_success: "发送成功",
    update_success: "更新成功",
  },
  popular_questions: {
    title1: "买到手提供什么服务？",
    p1: "全方位了解买到手可提供的服务方案",
    detail_txt: "查看详情",
    title2: "使用流程",
    p2: "简单2步将日本商品交付您手中",
    title3: "为何选择买到手？",
    p3: "全方位保障  商品轻松寄至全球各地",
    title4: "费用构成（免代购手续费）",
    p4: "透明收费  实时汇率  低价优质",
  },
  collection_info: {
    goods: "商品",
    seller: "店铺",
    category: "分类",
    keywords: "关键词",
    black_seller: "已屏蔽卖家",
    scmj: "收藏卖家",
    sccg: "收藏成功",
    qxsc: "取消收藏",
    lhmj: "屏蔽卖家",
    jclh: "解除屏蔽",
    lh: "屏蔽",
    jc: "解除",
    time_up: "最新收藏",
    time_down: "早期收藏",
    price_down: "价格从高到低",
    price_up: "价格从低到高",
    end_time_up: "结束时间较早",
    end_time_down: "结束时间较晚",
  },
  auction_info: {
    zl: "种类",
    kts: "可同时进行竞拍的数量",
    jped: "合计竞拍额度",
    qrkt: "确认开通",
    wxts: "温馨提示",
    tips: "确定要取消当前的竞拍信用等级吗？取消后，您将暂时无法参与代拍竞拍。如确认取消，已保留的",
    tips2: "元竞拍保证金将返还至您的钱包余额中。",
    yjbzj: "已缴保证金",
    qxbzj: "取消保证金",
    wkt: "未开通",
    current_level: "当前等级",
    level: "级",
    tip_submit: "继续开通",
    tip_cancel: "暂不开通",
    tip1: "- 关于竞拍得标后付款与弃标的说明",
    tip2: "当您竞拍得标（竞拍获胜）后，",
    tip2_1: "请于 48 小时内完成支付，",
    tip2_2: "以确保订单顺利成立。",
    tip3: "若超过 48 小时仍未完成支付，系统将视为自动弃标。届时将扣除竞拍保证金，并另行收取商品成交金额 30% 的弃标手续费。",
    tip4: "为避免产生相关费用，也为了不影响您的竞拍信用，建议您在结标后尽快完成支付。",
    tip5: "- 关于竞拍保证金解除",
    tip7: "当竞拍保证金解除后，对应金额将返还并存入您的账户余额中。",
    tip8: "账户余额可用于支付平台内的各项费用，包括商品款项、运费、服务费用等。",
    tip9: "如需将账户余额提现至您的个人账户，",
    tip10: "平台将按提现金额收取 2% 的提现手续费。",
    tip11: "请您在申请提现前确认相关费用说明。",
    tip12: "我已阅读并理解以上说明，并同意按规则执行",
  },
  mercari: {
    title: "日本煤炉",
    intro_desc: "日本最大的闲置交易平台",
  },
  yahoo_intro: {
    title: "雅虎拍卖",
    intro_desc: "日本最大的网络拍卖平台",
  },
  yahoo_paypay: {
    title: "Yahoo!フリマ",
    intro_desc: "Yahoo! JAPAN 旗下二手闲置交易平台",
  },
  rakuten: {
    title: "乐天",
    intro_desc: "日本最大的综合电商平台",
  },
  category_list: {
    home_text: "首页",
    all_text: "所有分类",
    clear_text: "清除条件",
    popular_categories: "热门分类",
    recommending_commodities: "精选专题",
    low_price: "最低价格",
    max_price: "最高价格",
    goods_price_text: "商品价格",
    goods_remark: "购买备注",
    glgzj: "关联搜索词",
    glgzh: "搜索词组合",
  },
  selfService: {
    title: "代购站点",
    dialog_tips: "您正在尝试访问以上链接，将前往外部浏览器打开。",
    intro_desc: "通过以下步骤进行代购",
    step1: "1. 找到希望购买的商品页面",
    step2: "2. 复制商品链接",
    step3: "3. 将购买链接复制到表单",
    submit_btn: "跳转到网站",
    tips: "关闭后将无法保存已填写的信息，确定关闭吗？",
    cancel_btn: "继续填写",
    close_btn: "确定关闭",
    add_href: "添加代购订单",
    add_title: "提交代购订单",
    url: "购买链接",
    goodsTitle: "商品标题",
    variant_name: "商品规格",
    variant_name_pla: "商品型号/颜色/尺寸 购买不同规格请多次提及代购订单！",
    price: "商品价格",
    num: "代购数量",
    note: "购买备注",
    thumb: "上传图片",
    notice: "代购须知",
    fwsm: "服务说明",
    ljgm: "立即购买",
    gwc: "加入购物车",
    notice1:
      "1. 由于海外代购的特殊性，商品下单支付后，无法单方面取消或者退换货。请下单前仔细阅读商品的详情描述再购买。",
    notice2:
      "2. 买到手仅提供交易平台和代购服务，无法保证卖家所售商品的真伪和质量，无法承担商品本身瑕疵或质量问题的赔偿责任。",
    notice3:
      "3. 商品价格为运费包含税费等购买时产生的费用的含税价格总和，如若商品运送到台湾需要支付额外费用的情况，在商品抵达买到手仓库时会向您请求产生的费用。",
    url_text: "输入商品链接，并点击按钮前往下一步",
    url_btn: "跳转至订购页面",
  },
  notice_info: {
    notice_title: "消息中心",
    no_new_notice: "还没有新的消息",
    gonggao: "公告消息",
    dingdan: "订单消息",
    paimai: "拍卖通知",
    zhannei: "站内消息",
    notify_setting: "通知设定",
    notify_receive: "接收推送通知",
    notify_notice: "公告信息",
    notify_order: "订单信息",
    notify_auction: "雅虎拍卖通知",
    notify_message: "站内通知",
    notify_save: "保存",
    notify_get_failed: "获取通知设定失败",
    notify_save_success: "保存成功",
    notify_save_failed: "保存失败",
  },
  footer: {
    service_related: "服务相关",
    use_instruction: "使用说明",
    help_center: "帮助中心",
    customer_service: "客服服务",
    privacy_protection: "隐私保护",
    user_agreement: "用户协议",
    payment_and_delivery_title: "支付与配送",
    cost_explanation: "费用说明",
    payment_method: "支付方式",
    delivery_explanation: "国际物流",
    prohibited_items: "禁运物品",
    about_tariff: "关于关税",
    about_us_title: "关于我们",
    company_profile: "公司简介",
    red_book: "小红书",
    douyin: "抖音",
    weibo: "微博",
    enterprise_customers: "企业客户",
    beware_of_fraud: "谨防诈骗",
    contact_us_title: "联系我们",
    customer_service_hours: "客服工作时间",
  },
  order_status: {
    pending_processing: "待处理",
    pending_processing2: "未处理",
    processing: "处理中",
    processing_pass: "已处理",
    fail_processing: "处理失败",
    pending_payment: "待付款",
    pending_stock_in: "待入库",
    pending_shipment: "待发货",
    pending_receipt: "待收货",
    completed: "已完成",
    cancelled: "已取消",
    order_name: "商品信息",
    package_name: "包裹信息",
    order_current_price: "当前价格",
    my_order_amount: "我的出价",
    work_order_type: "工单类型",
    order_nums: "重量",
    create_time: "建单时间",
    order_amount: "金额",
    order_status: " ",
    seller_shipped: "卖家已发货",
    order_operate: " ",
    order_remark: "订单备注",
    jxjj: "继续出价",
    min_bid_increment: "本次最少加价",
    min_bid_amount: "最少金额",
    remark: "备注",
    purchasing_fee: "代购手续费",
    fee_detail: "收费明细",
    current_exchange_rate: "当前汇率",
    total_goods_price: "商品总价",
    domestic_shipping_fee_in_japan: "日本国内运费",
    shipping_fee: "日本国内免运费",
    additional_service: "附加服务",
    coupon: "优惠券",
    ygq: "已过期",
    points_deduction: "积分抵扣",
    total_price: "总价格",
    order_details_btn: "订单详情",
    order_goods_title: "订单商品",
    end_time: "截止时间",
    shelves_time: "发货时间",
    stock_in_time: "入库时间",
    warehousing_days_unit: "天",
    warehousing_tip: "在库包裹提供免费30日仓储期",
    haitao_approved_label: "到手优运可发预估关税{tax}日元",
    haitao_approved_tip: "到手优运线路审核通过",
    ship_method_name: "运输方式",
    sm: "线路说明",
    logistics_no: "物流编号",
    xj: "小计",
    sm: "线路说明",
    sbzj: "申报总价",
    ship_fee: "运输费用",
    quantity: "数量",
    quantity2: "申报数量",
    mfee: "免运费",
    authenticity: "支持真伪鉴定",
    ys: "已售",
    zsbx: "暂时保留款项",
    zfdd: "支付订单",
    zjcz: "资金操作",
    zjje: "资金余额",
    mx: "明细",
    jfye: "积分余额",
  },
  bread: {
    personal_center: "个人中心",
    my_service_orders: "我的工单",
    inventory_check: "清点核对",
  },
  action: {
    all: "全部",
    leading: "领先中",
    booking: "预约中",
    won_bid: "已得标",
    wait_pay: "待支付",
    outbid: "被超越",
    ended: "已结束",
    tooltip_ended: "竞拍已结束，未中标的商品将于 24 小时后自动删除",
  },
  fundmanagement: {
    fund_record: "资金记录",
    withdrawal_record: "提领记录",
    points_record: "积分记录",
    account_balance: "账户余额",
    withdrawal: "提领",
    withdrawal_tip: "提领收取提领金额 2% 的手续费",
    chongzhi: "储值",
    money: "储值金额",
    money_title: "储值",
    money_tip: "请输入储值金额",
    account_name: "请输入要提领的账户(支付宝账户)",
    account_num: "请输入提领金额",
    payment_time: "付款时间",
    withdraw_time: "提领时间",
    withdraw_account: "提领时间",
    payment_account: "提领账户",
    amount_yuan: "金额（元）",
    tlzh: "提领账户",
    tlje: "提领金额",
    pay_order_item_type: "类型",
    pay_order_item_detail: "明细",
    pay_order_type_order: "订单",
    pay_order_type_package: "包裹",
    pay_order_type_payment_request: "费用请求",
    pay_order_type_recharge: "充值",
    pay_order_type_unknown: "未知",
    pay_order_number: "订单号",
    pay_order_record_id: "记录ID",
    pay_order_goods_id: "商品编号",
    pay_order_goods_title: "商品名称",
    pay_order_title: "费用标题",
    pay_order_desc: "费用说明",
    pay_order_create_time: "创建时间",
    pay_order_related_id: "关联记录ID",
    pay_order_detail_empty: "暂无明细",
  },
  bargain: {
    时间: "时间",
    备注: "备注",
    日元: "日元",
    议价详情: "议价详情",
    议价中: "议价中",
    议价成功: "议价成功",
    议价失败: "议价失败",
    待您确认: "待您确认",
    去确认: "去确认",
    议价至: "议价至",
    "日元, 议价状态": "日元, 议价状态",
    成交价格: "成交价格",
    取消购买: "取消购买",
    按还价金额购买: "按还价金额购买",
    按原价购买: "按原价购买",
    状态: "状态",
    "确定要取消当前议价订单吗？": "确定要取消当前议价订单吗？",
    订单取消成功: "订单取消成功",
    确定要按照卖家的还价金额: "确定要按照卖家的还价金额",
    "日元购买吗？": "日元购买吗？",
    "提交成功，我们即将使用": "提交成功，我们即将使用",
    日元与卖家沟通改价并购买: "日元与卖家沟通改价并购买",
    确定要按照原价: "确定要按照原价",
    日元购买吗: "日元购买吗",
    取消议价成功: "取消议价成功",
    设定议价金额成功: "设定议价金额成功",
  },
  auctionCenter: {
    竞价领先: "领先",
    预约中: "预约",
    被超越: "被超",
    "24小时内得标": "得标",
    "24小时内结束": "截标",
    截标时间较早: "截标时间较早",
    截标时间较晚: "截标时间较晚",
    竞拍价格从高到低: "竞拍价格从高到低",
    竞拍价格从低到高: "竞拍价格从低到高",
    最小宽度: "最小宽度",
    最大宽度: "最大宽度",
    还没有任何竞拍信息: "还没有任何竞拍信息",
    商品图片: "商品图片",
    商品ID: "商品ID",
    当前状态: "当前状态",
    去雅虎竞拍下标: "去雅虎竞拍下标",
    取消置顶: "取消置顶",
    数据加载中: "数据加载中",
    "输入数值进行排序，数值越大越靠前": "輸入數值進行排序，數值越大越靠前",
    排序值: "排序值",
    日元: "日元",
    出价: "出价",
    约: "约",
    取消: "取消",
    竞标日志: "竞标日志",
    未税: "未税",
    含税: "含税",
    立即出价: "立即出价",
    输入关键词可过滤: "输入关键词可过滤",
    "确定要清空竞标日志吗?": "确定要清空竞标日志吗?",
    最低出价: "最低出价",
    开启追踪: "开启追踪",
    取消追踪: "取消追踪",
    出价金额: "出价金额",
    含税金额: "含税金额",
    一口价购买: "一口价购买",
    确定要追踪这件商品吗: "确定要追踪这件商品吗",
    确定要取消追踪这件商品吗: "确定要取消追踪这件商品吗",
    "开启追踪后，以下情形将会提醒您：": "开启追踪后，以下情形将会提醒您：",
    "●竞拍金额发生变动时": "●竞拍金额发生变动时",
    "●距离竞拍结束剩余 15 分钟时": "●距离竞拍结束剩余 15 分钟时",
    "系统将通过 「APP 通知」 提醒您": "系统将通过 「APP 通知」 提醒您",
    当前最多可同时追踪: "当前最多可同时追踪",
    件商品: "個商品",
    价格变动: "价格变动",
    请输入出价金额: "請輸入出價金额",
    本次最少加价: "本次最少加价",
    竞拍中: "竞拍中",
    我的收藏: "我的收藏",
    "当客服非处于在线状态时，将无法为您处理备注事宜（9:00 - 16:30在线），这可能会导致商品在未得到最终确认前就被其他人购得。":
      "当客服非处于在线状态时，将无法为您处理备注事宜（9:00 - 16:30在线），这可能会导致商品在未得到最终确认前就被其他人购得。",
    "*请注意：填写备注则无法自动下单购买，需要人工确认后才能购买。":
      "*请注意：填写备注则无法自动下单购买，需要人工确认后才能购买。",
    请输入价格: "请输入价格",
    修改: "修改",
    元: "元",
    "可用积分不足，请重试": "可用积分不足，请重试",
    使用: "使用",
    取消订单: "取消订单",
    支付: "支付",
    "￥": "￥",
    "此费用为预估运费，实际运费以捆包后最终重量为准":
      "此费用为预估运费，实际运费以捆包后最终重量为准",
    立即支付: "立即支付",
    账单: "账单",
    通知: "通知",
    购物车: "购物车",
    收藏: "收藏",
    自助代购: "自助代购",
    竞拍中心: "竞拍中心",
    取消预约: "取消预约",
    取消收藏成功: "取消收藏成功",
    收藏成功: "收藏成功",
    复制成功: "复制成功",
    复制失败: "复制失败",
    在截止拍卖前5分钟时出价: "在截止拍卖前5分钟时出价",
    "确定要取消预约吗？": "确定要取消预约吗？",
    "商品ID、订单或商品标题": "商品ID、订单或商品标题",
    商品ID或商品标题: "商品ID或商品标题",
    页: "页",
    天: "天",
    时: "时",
    分: "分",
    秒: "秒",
    备注成功: "备注成功",
    默认: "默认",
    截标时间较晚优先: "截标时间较晚优先",
    截标时间较早优先: "截标时间较早优先",
    竞拍价格较高优先: "竞拍价格较高优先",
    竞拍价格较低优先: "竞拍价格较低优先",
    显示全部价格: "显示全部价格",
    仅显示日元: "仅显示日元",
    仅显示人民币: "仅显示人民币",
    关闭页面: "关闭页面",
    卡片显示: "卡片显示",
    单列显示: "单列显示",
    双列显示: "双列显示",
    三列显示: "三列显示",
    搜索: "输入竞拍ID、商品名称",
    较早收藏: "較早收藏",
    最新收藏: "最新收藏",
    log_被超越: "被超",
    log_价格变动: "变价",
    log_已得标: "得标",
    log_领先中: "领先",
    "当竞拍结束时间小于 1 小时，系统将自动更新价格与截标时间。":
      "当竞拍结束时间小于 1 小时，系统将自动更新价格与截标时间。",
    价格与截标时间自动更新中: "价格与截标时间自动更新中",
    "此商品竞拍价格未包含消费税，最终支付时将另加":
      "此商品竞拍价格未包含消费税，最终支付时将另加",
    "消费税计算总价。": "消费税计算总价。",
    商品信息不存在或已下架: "商品信息不存在或已下架",
    "确定要清空已结束的雅虎竞拍商品吗？": "确定要清空已结束的雅虎竞拍商品吗？",
    该商品涉及不良信息已禁止访问: "该商品涉及不良信息已禁止访问",
    "如您认为此商品没有涉及不良信息，请联系客服处理。":
      "如您认为此商品没有涉及不良信息，请联系客服处理。",
  },
};
